import { Link } from "react-router-dom";

/**
 * V15 close-out — single shared CTA pointing every marketing surface at /pricing.
 * The pricing page is the canonical conversion surface; this component lets us
 * sweep every "Upgrade" / "See plans" link to the same destination without
 * duplicating route literals across the codebase.
 */
export default function SeePricingLink({
  label = "See all plans →",
  className = "",
  testid = "see-pricing-link",
}) {
  return (
    <Link
      to="/pricing"
      data-testid={testid}
      className={`text-sm font-semibold text-[#2D6A4F] hover:text-[#1B4332] underline-offset-2 hover:underline ${className}`}
    >
      {label}
    </Link>
  );
}
